import { largeScreen } from '../../variables/media';

const initNavItemDropdownHover = () => {
  const openDelay = 500;
  const closeDelay = 500;

  document.querySelectorAll('[data-header-nav-item-dropdown]').forEach((item: HTMLElement) => {
    const dropdown = document.querySelector(item.dataset.target);

    if (null === dropdown) {
      return;
    }

    let openTimer;
    let closeTimer;

    // Open dropdown handler
    const open = () => {
      // Dropdowns are only available for big screen.
      if (!largeScreen('min')) {
        return;
      }

      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = undefined;
      }

      openTimer = setTimeout(() => {
        item.classList.add('open');
        dropdown.classList.add('show');
        document.body.classList.add('nav-dropdown-active');
      }, openDelay);
    };

    // Close dropdown handler
    const close = (delay = closeDelay) => {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = undefined;
      }

      closeTimer = setTimeout(() => {
        item.classList.remove('open');
        dropdown.classList.remove('show');
        document.body.classList.remove('nav-dropdown-active');
      }, delay);
    };

    // Since the menu item and its dropdown menu are not in the same container, we need to trick with timers and listeners attached to both.
    item.addEventListener('mouseenter', () => open());
    dropdown.addEventListener('mouseenter', () => open());

    item.addEventListener('mouseleave', () => close());
    dropdown.addEventListener('mouseleave', () => close());

    // Initialize close handler
    dropdown.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;

      if (!target.matches('[data-dismiss="nav-item-dropdown"]')) {
        return;
      }

      close(0);
    });
  });
};

export default initNavItemDropdownHover;
